// src/features/live/filterLive.ts — pure chip filtering for the Live page.
// Mirrors src/features/videos/filterVideos.ts, minus the special 'trending' /
// 'latest' / 'following' chips Videos has — Live's chip row is just 'all' plus
// categories (see meta.ts).
import type { LiveChannel, LiveChipId } from '@/core/models/live';

export interface LiveFilterOptions {
  chip: LiveChipId;
}

/** Pure: filter live channels by the active chip. Never mutates input. */
export function filterLive(items: LiveChannel[], opts: LiveFilterOptions): LiveChannel[] {
  if (opts.chip === 'all') return items;
  return items.filter((c) => c.category === opts.chip);
}
